module.exports = __webpack_public_path__ + "static/media/Cafe.24a77f85.ogg";